.tag {
  display: inline-flex;
  align-items: center;
  margin-left: var(--tuna-spacing-1);
  padding: 0 var(--tuna-spacing-1);
  font: inherit;
  font-size: var(--tuna-typography-fontSize-xs);
  line-height: 1.6;
  color: var(--tuna-palette-text-secondary);
  background: transparent;
  border: none;
  border-radius: var(--tuna-shape-borderRadius);
  cursor: pointer;
  /* Non-chromatic affordance: ghost-styled tag with subtle dotted underline so
   * the role reads as "secondary commentary" without relying on color alone.
   * Joni's UX spec §2.1: end-of-line tag, no fill. */
  text-decoration: underline dotted var(--tuna-palette-text-secondary);
  text-underline-offset: 2px;
}

.tag:hover {
  color: var(--tuna-palette-text-primary);
  background-color: var(--tuna-palette-action-hover);
}

.tag:focus-visible {
  outline: 2px solid var(--tuna-palette-primary-main);
  outline-offset: 1px;
}

.separator {
  margin: 0 var(--tuna-spacing-1);
  color: var(--tuna-palette-divider);
  font-weight: 600;
}

@media (max-width: 599.95px) {
  /* Joni's UX spec §2.1: mobile drops the tag below right-aligned. The chord
   * plugin renders WindowTag inline next to the closing chord; the mobile
   * wrap is handled by the parent line's flex-wrap. The tag itself shifts to
   * a block-level display so it wraps to its own line. */
  .tag {
    display: flex;
    width: 100%;
    justify-content: flex-end;
    margin-left: 0;
    margin-top: var(--tuna-spacing-0_5, 4px);
  }
}
